<div class="confirmation-dialog">
  <div class="dialog-header" [ngClass]="'dialog-header-' + (data.type || 'warning')">
    <mat-icon class="dialog-icon">{{ icon }}</mat-icon>
    <h2 mat-dialog-title class="dialog-title">{{ data.title }}</h2>
  </div>

  <mat-dialog-content class="dialog-content">
    <p class="dialog-message" [innerHTML]="data.message"></p>
    @if (data.showTextarea) {
      <mat-form-field appearance="outline" class="textarea-field">
        <mat-label>{{ data.textareaLabel || 'Reason' }}</mat-label>
        <textarea
          matInput
          rows="4"
          maxlength="500"
          [placeholder]="data.textareaPlaceholder || 'Enter reason...'"
          [required]="data.textareaRequired || false"
          [(ngModel)]="textareaValue"></textarea>
        @if (data.textareaRequired) {
          <mat-hint>Required</mat-hint>
        }
      </mat-form-field>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    @if (!data.hideCancel) {
      <button
        mat-stroked-button
        class="cancel-button"
        (click)="onCancel()">
        {{ cancelText }}
      </button>
    }
    <button
      mat-raised-button
      class="confirm-button"
      [color]="data.type === 'danger' ? 'warn' : 'primary'"
      [disabled]="isConfirmDisabled"
      (click)="onConfirm()">
      {{ confirmText }}
    </button>
  </mat-dialog-actions>
</div>
